import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'transferType',
      type: 'select',
      label: '转移类型',
      options: [
        {title: '在职业务员客户', value: ''},
        {title: '离职未分配业务员客户', value: '1'},
      ]
    },
    {
      field: 'sid',
      type: 'input',
      label: '账号ID',
      placeholder: '请输入账号ID'
    },
    {
      field: 'sname',
      type: 'input',
      label: '账号名称',
      placeholder: '请输入账号名称'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'uname',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'removeD',
      type: 'switch',
      label: '排除成、删',
      activeValue: '1',
      inActiveValue: '0'
    }
  ]
}
